import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/app-modals/services/modal.service';

/**
 * App footer component
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  public year: number;

  constructor(private appModal: ModalService) {}

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  openHelpModal(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();

    this.appModal.showHelpModal({});
  }
}
